import { Component } from '@angular/core';

@Component({
    selector: 'organizer-event-calendar',
    templateUrl: './organiser-dashboard.component.html',
    styleUrls: ['./organizer-dashboard.component.scss'],
    standalone: false
})
export class OrganizerDashboardComponent {
}
